import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Qualification } from '@ps/survey-utils';

import { QualificationsApi } from '../../api/qualifications/qualifications.api';

@Injectable({ providedIn: 'root' })
export class QualificationsService {
  private readonly _api = inject(QualificationsApi);

  public getQualifications(
    countryCode: string,
    languageShortCode: string,
  ): Observable<Qualification[]> {
    return this._api.getQualifications(countryCode, languageShortCode);
  }
}
